import React, { useEffect, useState } from 'react';
import { predictiveService } from './predictiveService';

export const HealthScoreHeatmap: React.FC = () => {
  const [heatmap, setHeatmap] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHeatmap = async () => {
      try {
        const data = await predictiveService.getHealthHeatmap();
        setHeatmap(data);
      } catch (err) {
        console.error('Failed to fetch risk heatmap', err);
      } finally {
        setLoading(false);
      }
    };
    fetchHeatmap();
  }, []);

  if (loading) return <div>Loading Risk Heatmap...</div>;
  if (!heatmap) return <div>No heatmap data</div>;

  const getStatusColor = (score: number) => {
    if (score >= 80) return 'status-green';
    if (score >= 60) return 'status-yellow';
    if (score >= 40) return 'status-orange';
    return 'status-red';
  };

  return (
    <div className="module-predictive">
      <h3>Enterprise Health Heatmap</h3>
      <div className="summary-bar">
        <span className="badge green">Healthy: {heatmap.summary.healthy}</span>
        <span className="badge yellow">Monitor: {heatmap.summary.monitor}</span>
        <span className="badge orange">Risk: {heatmap.summary.risk}</span>
        <span className="badge red">Critical: {heatmap.summary.critical}</span>
      </div>
      
      <table className="heatmap-table">
        <thead>
          <tr>
            <th>Enterprise</th>
            <th>Health Score</th>
            <th>Churn Risk</th>
            <th>Budget Risk</th>
            <th>Margin Risk</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {heatmap.entities.map((entity: any) => (
            <tr key={entity.company_id}>
              <td>{entity.name}</td>
              <td className={getStatusColor(entity.composite_score)}>
                {entity.composite_score}
              </td>
              <td>{entity.churn_risk_score}</td>
              <td>{entity.budget_risk_score}</td>
              <td>{entity.margin_risk_score}</td>
              <td>{entity.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
